import thunk from 'redux-thunk';
import { logger } from 'redux-logger';
import type { Middleware } from 'redux';
import appReducer from '@/redux/reducers';
import { configureStore } from '@reduxjs/toolkit';

import { initialState as auth } from '@/redux/auth/reducer';
import { initialState as user } from '@/redux/user/reducer';
import { initialState as campaign } from '@/redux/campaign/reducer';

const rootStoreConfig = {
  preloadedState: { auth, user, campaign },
  middleware: [thunk] as Middleware[],
  devTools: import.meta.env.DEV,
  reducer: appReducer
};

const enableLogger = import.meta.env.DEV && !TEST;
enableLogger && rootStoreConfig.middleware.push(logger);

export default configureStore(rootStoreConfig);
